module.exports = "<light-core-selector-item class=\"u-block\"  on-index-change=\"_onIndexChange\" on-selected-index-change=\"_onSelectedIndexChange\"></light-core-selector-item>\n<content></content>";
